var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap items-center justify-between mb-2" },
        [
          _c("div", { staticClass: "text-muted" }, [
            _vm.subscribers.length
              ? _c("span", [
                  _vm._v(_vm._s(_vm.subscribers.length) + " assinante(s)"),
                ])
              : _c("span", [_vm._v("Nenhum assinante ainda")]),
          ]),
          _c(
            "b-button",
            {
              attrs: { variant: "outline-primary", size: "sm" },
              on: { click: _vm.load },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "RefreshCwIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v("Atualizar"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-table",
        {
          attrs: {
            data: _vm.subscribers,
            "no-data-text": "Nenhum assinante encontrado",
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var data = ref.data
                return _vm._l(data, function (tr) {
                  return _c(
                    "vs-tr",
                    { key: "sub-" + tr.subscription_id },
                    [
                      _c("vs-td", [
                        _c("div", [_vm._v(_vm._s(tr.user_name))]),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(tr.user_email)),
                        ]),
                      ]),
                      _c(
                        "vs-td",
                        [
                          _c(
                            "vs-chip",
                            { attrs: { color: _vm.statusColor(tr.status) } },
                            [_vm._v(_vm._s(tr.status_label))]
                          ),
                        ],
                        1
                      ),
                      _c("vs-td", [
                        tr.slots.length
                          ? _c(
                              "div",
                              { staticClass: "flex flex-wrap gap-1" },
                              _vm._l(tr.slots, function (slot) {
                                return _c(
                                  "vs-chip",
                                  { key: slot.id, attrs: { color: "primary" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.shortLabel(slot)) + " "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _c("small", { staticClass: "text-muted" }, [
                              _vm._v("Sem horários fixos"),
                            ]),
                      ]),
                      _c("vs-td", [
                        _vm._v(
                          _vm._s(
                            tr.next_billing_at
                              ? _vm.formatDate(tr.next_billing_at)
                              : "—"
                          )
                        ),
                      ]),
                      _c(
                        "vs-td",
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.auto",
                                value: {
                                  content: "Abrir assinatura",
                                  delay: { show: 500, hide: 100 },
                                },
                                expression:
                                  "{ content: 'Abrir assinatura', delay: { show: 500, hide: 100 } }",
                                modifiers: { auto: true },
                              },
                            ],
                            staticClass: "h-5 w-5 stroke-current text-primary",
                            staticStyle: { cursor: "pointer" },
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "/subscriptions/" + tr.subscription_id
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", [_vm._v("Aluno")]),
              _c("vs-th", [_vm._v("Situação")]),
              _c("vs-th", [_vm._v("Grade de horários")]),
              _c("vs-th", [_vm._v("Renova em")]),
              _c("vs-th", [_vm._v("Ação")]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }